module.exports = __webpack_public_path__ + "img/nav-design-coloredstones.6f2d313.jpg";